import React from "react";
import styled from "styled-components";

const Card = styled.div<{ selected?: boolean; soon?: boolean }>`
  width: 199.5px;
  height: 98px;
  border: 1px solid ${({ selected }) => (selected ? "#5B3FFF" : "#E6E6F2")};
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 24px;
  position: relative;
  margin: 0;
  box-shadow: 0px 8px 8px 0px #f1f5f9;
  transition: border 0.2s;
  overflow: hidden;
  opacity: ${({ soon }) => (soon ? 0.5 : 1)};
`;

const SoonBadge = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  background: #5b3fff;
  color: #fff;
  border-radius: 20px;
  padding: 2px 16px;
  font-size: 13px;
  font-weight: 500;
`;

const IconWrapper = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  margin-left: 12px;
`;

const Name = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #331860;
  margin-left: 12px;
  margin-bottom: 12px;
`;

interface ChannelCardProps {
  icon: React.ReactNode;
  name: string;
  soon?: boolean;
  selected?: boolean;
}

const ChannelCard: React.FC<ChannelCardProps> = ({
  icon,
  name,
  soon,
  selected,
}) => {
  return (
    <Card selected={selected} soon={soon}>
      {soon && <SoonBadge>قريبا</SoonBadge>}
      <IconWrapper>{icon}</IconWrapper>
      <Name>{name}</Name>
    </Card>
  );
};

export default ChannelCard;
